import React from "react";
import { NewTab, PageTab } from "../../../../components";
import InvoiceGenerator from "./PdfGeneratorList/InvoiceGenerator";
import TimesheetGenerator from "./PdfGeneratorList/TimesheetGenerator";

const PdfGeneratorList = () => {
  const tabs = [
    {
      title: "Timesheet",
      page: <TimesheetGenerator />,
      type: "main",
    },
    {
      title: "Invoice",
      page: <InvoiceGenerator />,
      type: "main",
    },
  ];
  return (
    <div className="w-full h-full flex-1 flex">
      <NewTab
        tabs={tabs}
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="pdf-generator-list"
      />
    </div>
  );
};

export default PdfGeneratorList;
